import { listingArticlesBlogMock, rubriquesBlogMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listingArticlesBlogMock('b2c', 'Agencement'), rubriquesBlogMock];

export const blogB2cInspirationMock: SlugPage = {
  ...pageBase({
    title: 'Blog B2c',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    headerSubMenuId: 'menu-blog-b2c',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
